import Vuex from 'vuex';
import registration from './registration.module';

// Vue is the CDN global (webpack external). Register Vuex against it.
Vue.use(Vuex);

export default function createStore() {
  return new Vuex.Store({
    modules: {
      registration,
    },
  });
}
